// eslint-disable-next-line max-classes-per-file
import { type ErrorResponse } from './types';

export class HTTPError extends Error {

  constructor(
    public readonly status: number,
    public readonly statusText: string,
    public readonly response: ErrorResponse
  ) {
    super(statusText);
  }

}

export class ClientError extends Error {}
